import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

const BASE_URL = 'https://api.djkdurlach.de/index.php';

const fetchTrainings = async () => {
  const response = await fetch(`${BASE_URL}/trainings`, {
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error('Failed to fetch trainings');
  }
  const data = await response.json();
  return Array.isArray(data)
    ? data.sort((a, b) => (a.pos ?? 0) - (b.pos ?? 0))
    : data;
};

const saveTraining = async (training) => {
  const response = await fetch(`${BASE_URL}/trainings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(training),
  });
  if (!response.ok) {
    throw new Error('Failed to save training');
  }
  return response.json();
};

const deleteTraining = async (id) => {
  const response = await fetch(`${BASE_URL}/trainings/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error('Failed to delete training');
  }
  return response.json();
};

export const useTrainings = () => {
  return useQuery({
    queryKey: ['trainings'],
    queryFn: fetchTrainings,
  });
};

export const useSaveTraining = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveTraining,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trainings'] });
    },
  });
};

export const useDeleteTraining = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteTraining,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trainings'] });
    },
  });
};